/**
 * Blockchain utility functions
 */

/**
 * Get blockchain brand color by code
 */
export function getBlockchainColor(code: string): string {
  const colors: Record<string, string> = {
    ETH: '#627EEA', // Ethereum blue
    BTC: '#F7931A', // Bitcoin orange
    TRX: '#FF0013', // Tron red
    MATIC: '#8247E5', // Polygon purple
    SOL: '#14F195', // Solana green
    ARB: '#28A0F0', // Arbitrum blue
    BSC: '#F3BA2F', // Binance Smart Chain yellow
    AVAX: '#E84142', // Avalanche red
  }
  return colors[code] || '#666666'
}

/**
 * Get blockchain symbol/abbreviation by code
 */
export function getBlockchainSymbol(code: string): string {
  const symbols: Record<string, string> = {
    ETH: 'ETH',
    BTC: 'BTC',
    TRX: 'TRX',
    MATIC: 'MATIC',
    SOL: 'SOL',
    ARB: 'ARB',
    BSC: 'BSC',
    AVAX: 'AVAX',
  }
  return symbols[code] || code.slice(0, 3).toUpperCase()
}
